<template>
	<div class="view-claim-page p-3 sm:p-4 md:p-6 bg-background min-h-screen w-full">
		<div class="mb-4 sm:mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
			<h1 class="text-xl sm:text-2xl md:text-3xl font-bold text-text-primary">
				Claim Details
			</h1>
			<button
				@click="goBack"
				class="w-full sm:w-auto px-4 py-2.5 text-sm bg-primary text-white rounded-lg hover:bg-primary-light transition-colors touch-manipulation"
			>
				Back
			</button>
		</div>

		<div class="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
			<div class="h-full">
				<CardComponent
					title="Policy Details"
					icon="fa fa-shield-alt"
					icon-color="#0A0D57"
					icon-bg="bg-blue-50"
					class="h-full"
				>
					<template #header-actions>
						<button
							class="px-4 py-2 text-sm bg-primary text-white rounded-lg hover:bg-primary-light transition-colors"
						>
							View Policy
						</button>
					</template>
					<div class="space-y-4">
						<div class="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
							<div
								class="w-12 h-12 sm:w-16 sm:h-16 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0"
							>
								<i
									class="fa fa-building text-lg sm:text-2xl text-primary"
								></i>
							</div>
							<div class="flex-1 min-w-0">
								<p class="text-xs text-text-secondary mb-1">
									Underwriter
								</p>
								<p class="font-semibold text-text-primary truncate">
									Invicible Motor
								</p>
							</div>
						</div>

						<div class="grid grid-cols-2 gap-4">
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Cover
								</p>
								<p
									class="text-sm font-medium text-text-primary"
								>
									3rd Party
								</p>
							</div>
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Status
								</p>
								<p
									class="text-sm font-medium text-text-primary"
								>
									Active
								</p>
							</div>
						</div>

						<div class="grid grid-cols-2 gap-4">
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Intermediary
								</p>
								<p
									class="text-sm font-medium text-text-primary"
								>
									Premium
								</p>
							</div>
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Premium
								</p>
								<p
									class="text-sm font-medium text-text-primary"
								>
									KSh 50,000
								</p>
							</div>
						</div>
					</div>
				</CardComponent>
			</div>

			<div class="h-full">
				<CardComponent
					title="Claim Details"
					icon="fa fa-file-alt"
					icon-color="#FF1D1D"
					icon-bg="bg-red-50"
					class="h-full"
				>
					<div class="space-y-4">
						<div class="grid grid-cols-2 gap-4">
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Claim Date
								</p>
								<p
									class="text-sm font-medium text-text-primary"
								>
									10/10/2024
								</p>
							</div>
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Category
								</p>
								<p
									class="text-sm font-medium text-text-primary"
								>
									Report
								</p>
							</div>
						</div>

						<div class="grid grid-cols-2 gap-4">
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Status
								</p>
								<span
									class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-amber-50 text-amber-700"
								>
									Work in Progress
								</span>
							</div>
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Procuring
								</p>
								<p
									class="text-sm font-medium text-text-primary"
								>
									KBB 330X
								</p>
							</div>
						</div>

						<div class="grid grid-cols-2 gap-4">
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Claim Ref
								</p>
								<p
									class="text-sm font-medium text-text-primary"
								>
									Remarks
								</p>
							</div>
							<div>
								<p class="text-xs text-text-secondary mb-1">
									Claim Type
								</p>
								<p
									class="text-sm font-medium text-text-primary"
								>
									Accident
								</p>
							</div>
						</div>
					</div>
				</CardComponent>
			</div>
		</div>

		<div class="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-6 sm:mb-8 px-2">
			<button
				class="w-full sm:w-auto px-6 sm:px-8 py-3 bg-primary hover:bg-primary-light text-white font-medium rounded-lg transition-colors touch-manipulation"
			>
				Submit
			</button>
			<button
				class="w-full sm:w-auto px-6 sm:px-8 py-3 border border-border hover:bg-gray-50 text-text-primary font-medium rounded-lg transition-colors touch-manipulation"
			>
				Cancel
			</button>
		</div>

		<div class="mb-6 sm:mb-8 w-full">
			<TabsComponent
				:tabs="claimTabs"
				:default-tab="0"
				@tab-change="handleTabChange"
			>
				<template #tab-0>
					<ClaimFormTab
						:damage-images="damageImages"
						:current-image-index="currentImageIndex"
						@previous-image="previousImage"
						@next-image="nextImage"
						@update:current-image-index="currentImageIndex = $event"
					/>
				</template>

				<template #tab-1>
					<TrackTab />
				</template>

				<template #tab-2>
					<ActionsTab />
				</template>

				<template #tab-3>
					<NotificationsTab />
				</template>
			</TabsComponent>
		</div>
	</div>
</template>

<script>
import TabsComponent from './../templates/others/Tabs.vue';
import CardComponent from './../templates/others/Card.vue';
import ClaimFormTab from './../templates/others/viewclaimcomponents/ClaimFormTab.vue';
import ActionsTab from './../templates/others/viewclaimcomponents/ActionsTab.vue';
import NotificationsTab from './../templates/others/viewclaimcomponents/NotificationsTab.vue';
import TrackTab from './../templates/others/viewclaimcomponents/TrackTab.vue';

export default {
	name: 'ViewClaimPage',
	components: {
		TabsComponent,
		CardComponent,
		ClaimFormTab,
		ActionsTab,
		NotificationsTab,
		TrackTab,
	},
	data() {
		return {
			claimTabs: [
				{ label: 'Claim Form', icon: 'fa fa-file-alt' },
				{ label: 'Track', icon: 'fa fa-map-marker-alt' },
				{ label: 'Actions', icon: 'fa fa-tasks' },
				{ label: 'Notifications', icon: 'fa fa-bell' },
			],
			damageImages: [],
			currentImageIndex: 0,
		};
	},
	methods: {
		goBack() {
			this.$router.push({ name: 'NewPortalClaims' });
		},
		handleTabChange(data) {
			console.log('Tab changed:', data);
		},
		previousImage() {
			if (this.currentImageIndex > 0) {
				this.currentImageIndex--;
			}
		},
		nextImage() {
			if (this.currentImageIndex < this.damageImages.length - 1) {
				this.currentImageIndex++;
			}
		},
	},
};
</script>

<style scoped></style>
